/**
 * This component renders the top banner for a Division page
 */

import React from "react";
import TabButton from "../core/TabButton";

const DivisionBanner = ({ activeTab, handleTabClick, div_data, doStandings = false, doPowerRankings = false, doAllStars = false }) => {
  return (
    <div className="w-full homegradient bg-gradient-to-r from-blue-600 to-red-600 border-b-2 border-light-3 dark:border-dark-3">
      <div className="flex flex-row justify-between items-center border-1 border-white rounded-lg">
        <div className="flex flex-col w-full justify-between items-left border-1 border-blue">
          <div className="flex flex-row w-full justify-center items-center py-2">
            {/* Club logo */}
            <img src={`/buihamini.png`} alt="BUIHA" className="h-20 w-20" />

            {/* Information section container- Club name and other info*/}
            <div className="flex flex-col justify-left items-left xxs:mx-4">
              {/* Club name*/}
              <h1 className="xxs:text-4xl text-2xl xs:text-5xl pb-1 text-white font-semibold leading-tight text-center">
                {div_data.name + " " + div_data.season}
              </h1>
            </div>
          </div>

          {/* Tab switch buttons */}
          <div className="flex flex-row justify-center items-center">
            { doStandings ? (
            <TabButton
              tabName="standings"
              activeTab={activeTab}
              handleTabClick={handleTabClick}
              label="Overview"
              first={true}
            />
            ) : null }
            <TabButton
              tabName="schedule"
              activeTab={activeTab}
              handleTabClick={handleTabClick}
              label="Schedule"
              first={doStandings ? false : true}
            />
            <TabButton
              tabName="stats"
              activeTab={activeTab}
              handleTabClick={handleTabClick}
              label="Stats"
            />
            {/*{ doPowerRankings ? (*/}
            {/*    <TabButton*/}
            {/*        tabName="rankings"*/}
            {/*        activeTab={activeTab}*/}
            {/*        handleTabClick={handleTabClick}*/}
            {/*        label="Rankings"*/}
            {/*        />*/}
            {/*) : null }*/}
            { doAllStars ? (
                <TabButton
                    tabName="allstars"
                    activeTab={activeTab}
                    handleTabClick={handleTabClick}
                    label="AllStars"
                />
            ) : null }
          </div>
        </div>
      </div>
    </div>
  );
};

export default DivisionBanner;
